import React, { useState, useEffect, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import IncidenceForm from './IncidenceForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import { StatusPill, ActionIconButton, ListPageShell, SideDrawer, EmptyState } from '../../Components/Ui'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import IncidenceSolution from './IncidenceSolution';
import IncidenceClose from './IncidenceClose';

function TooltipButton({ tooltip, button, id }) {
    return (
      <>
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id={id}>
                    {tooltip}
                </Tooltip>
            }
        >
            {button}
        </OverlayTrigger>
      </>
    );
  }

const Incidence = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [dataClose, setDataClose] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [localSearch, setLocalSearch] = useState('')
    const [tableFilter, setTableFilter] = useState('')

    const [modalShowReply, setModalShowReply] = useState(false);
    const [modalTitleReply, setModalTitleReply] = useState('');
    const [dataComments, setDatComments] = useState('')
    const [modalShowClose, setModalShowClose] = useState(false);
    const [modalTitleClose, setModalTitleClose] = useState('');
    const [loadSubmitClose, setLoadSubmitClose] = useState(false)

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.incidence.get_incidence().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.incidence.incidence_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
            setReload(true)
        })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idIncidence) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i className="fa fa-circle-notch fa-spin"></i>'
        let { idIncidence } = $this.dataset

        Controllers.incidence.get_incidence_id({ p_id_incidence: idIncidence }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idIncidence}`)
            setDataUpdated({ data: res.data })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
        .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleOpenCreate = () => {
        setModalTitle(`Registrar ${nameSingle}`)
        setDataUpdated({})
        setModalShow(true)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.incidence.incidence_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setReload(true)
            setLoadSubmitDelete(false)
        })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idIncidence, descriptionIncidence } = e.currentTarget.dataset
        setDataDeleted({
            p_id_incidence: idIncidence,
            p_description_incidence: descriptionIncidence
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const handleShowModalReply = e => {
        let { idIncidence } = e.currentTarget.dataset
        setDatComments(idIncidence)
        setModalTitleReply('Incidencia #' + idIncidence)
        setModalShowReply(true)
    }

    const handleShowModalClose = e => {
        let { idIncidence } = e.currentTarget.dataset
        setDataClose(idIncidence)
        setModalTitleClose('Incidencia #' + idIncidence)
        setModalShowClose(true)
    }

    const handleSubmitClose = ({ data }) => {
        setLoadSubmitClose(true)
        Controllers.incidence.incidence_close(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShowClose(false)
                setDataClose({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmitClose(false)
            setReload(true)
            setLoadSubmit(false)
        })
    }

    const applySearch = () => setTableFilter(localSearch)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        textFilter={tableFilter}
        hideSearch
        head={[
            [
                { name: 'id_incidence', text: 'ID', align: 'center' },
                { name: 'date_incidence', text: 'Fecha' },
                { name: 'folio_incidence', text: 'Folio' },
                { name: 'name_category', text: 'Departamento' },
                { name: 'description_incidence', text: 'Descripción' },
                { name: 'g', text: 'G', align: 'center', render: r => parseInt(r.g) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i> },
                { name: 'sg', text: 'SG', align: 'center', render: r => parseInt(r.sg) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'rh', text: 'RH', align: 'center', render: r => parseInt(r.rh) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'adc', text: 'ADC', align: 'center', render: r => parseInt(r.adc) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'ca', text: 'CA', align: 'center', render: r => parseInt(r.ca) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'ao', text: 'AO', align: 'center', render: r => parseInt(r.ao) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'lic', text: 'LIC', align: 'center', render: r => parseInt(r.lic) > 0 ? <i className="fas fa-check-circle text-success"></i> : <i className="fas fa-clock text-warning"></i>  },
                { name: 'solution_incidence', text: 'Solución de Gerencia Sucursal' },
                { name: 'date_close_incidence', text: 'Fecha de Cierre' },
                { name: 'folio_close_incidence', text: 'Folio de Cierre' },
                { name: 'state_incidence', text: 'Estado', align: 'center', render: r => <StatusPill tone={parseInt(r.state_incidence) === 1 ? 'info' : 'dark'}>
                    {parseInt(r.state_incidence) === 1 ? 'En Proceso' : 'Cerrado'}
                </StatusPill> },
                { name: 'actions', style: { minWidth: 135 }, text: 'Acciones', align: 'center', render: u => {
                    return <div className="sp-row-actions">
                        {parseInt(u.state_incidence) === 1 ? <TooltipButton
                            tooltip="Modificar"
                            id={'btn-incidence-edit-' + u.id_incidence}
                                button={<ActionIconButton tone="ghost" icon="fa fa-pen" label="Editar" data-id-incidence={u.id_incidence} onClick={handleGet} />}
                        /> : ''}
                        <TooltipButton
                            tooltip="Eliminar"
                            id={'btn-incidence-delete-' + u.id_incidence}
                            button={<ActionIconButton tone="danger" icon="fa fa-trash" label="Eliminar" data-id-incidence={u.id_incidence} data-description-incidence={u.description_incidence} onClick={handleShowModalDelete} />}
                        />
                        {parseInt(u.state_incidence) === 1 ? <TooltipButton
                            tooltip="Brindar Solución"
                            id={'btn-incidence-solution-' + u.id_incidence}
                            button={<ActionIconButton tone="secondary" icon="fas fa-reply" label="Solución" data-id-incidence={u.id_incidence} data-description-incidence={u.description_incidence} onClick={handleShowModalReply} />}
                        /> : ''}
                        {parseInt(u.state_incidence) === 1 ? <TooltipButton
                            tooltip="Cerrar Incidencia"
                            id={'btn-incidence-close-' + u.id_incidence}
                            button={<ActionIconButton tone="secondary" icon="fas fa-times" label="Cerrar" data-id-incidence={u.id_incidence} onClick={handleShowModalClose} />}
                        /> : ''}
                    </div>
                } },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, tableFilter])

    const showEmpty = !isProcessing && rows.length === 0

    return <>
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={`Listado de ${namePlural}`}
            subtitle="Da seguimiento a incidencias, soluciones y cierres desde un solo lugar."
            badge="Actividad actualizada"
            primaryAction={
                <ListPageShell.PrimaryButton onClick={handleOpenCreate} icon="fa fa-plus">
                    Registrar {nameSingle}
                </ListPageShell.PrimaryButton>
            }
            onSearch={applySearch}
            filters={[
                {
                    label: 'Buscar',
                    control: (
                        <input
                            type="search"
                            placeholder="Folio, departamento…"
                            value={localSearch}
                            onChange={e => setLocalSearch(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') applySearch() }}
                        />
                    )
                }
            ]}
        >
            {showEmpty ? (
                <EmptyState
                    icon="fa fa-exclamation-circle"
                    title={`No hay ${namePlural.toLowerCase()} para mostrar`}
                    text="Ajusta la búsqueda o registra una nueva incidencia para empezar."
                    action={
                        <ListPageShell.PrimaryButton onClick={handleOpenCreate}>
                            Registrar {nameSingle}
                        </ListPageShell.PrimaryButton>
                    }
                />
            ) : (
                <div className="sp-table-wrap">{dtRows}</div>
            )}
        </ListPageShell>

        <SideDrawer
            open={modalShow}
            onClose={handleHideModalForm}
            title={modalTitle}
            subtitle="Los cambios se guardan al confirmar el formulario."
        >
            <IncidenceForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
        </SideDrawer>

        <Modal show={modalShowReply} size="xl" onHide={_ => setModalShowReply(false)} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitleReply}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <IncidenceSolution idIncidence={dataComments} onSubmit={_ => setReload(true)} />
            </Modal.Body>
        </Modal>

        <SideDrawer
            open={modalShowClose}
            onClose={_ => setModalShowClose(false)}
            title={modalTitleClose}
            subtitle="Confirma el cierre de la incidencia."
        >
            <IncidenceClose loadSubmit={loadSubmitClose} onSubmit={handleSubmitClose} idIncidence={dataClose} />
        </SideDrawer>

        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_incidence} - {dataDeleted.p_description_incidence}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default Incidence
